import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const RiverOaks = () => {
  const content = getAreaContent("river-oaks");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default RiverOaks;